module.exports = __webpack_public_path__ + "static/media/MOYSES_CAMISA.3b49d05f.png";